export default "__VITE_ASSET__Bv1C2jQF__"